<template>
    <div id="app">
        <TopHeader></TopHeader>
        <router-view/>
        <BottomFooter></BottomFooter>
    </div>
</template>

<script>
    // @ is an alias to /src
    import TopHeader from '@/components/TopHeader.vue'
    import BottomFooter from '@/components/BottomFooter.vue'

    export default {
        name: 'home',
        components: {
            TopHeader, BottomFooter
        },
        mounted(){
            if(navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Android') > -1){
                // mobile
                window.location.href='/mobile'
            }
        }
    }
</script>

<style lang="stylus">
    body
        margin 0
    #app
        font-family 'Avenir', Helvetica, Arial, sans-serif
        -webkit-font-smoothing antialiased
        -moz-osx-font-smoothing grayscale
        text-align center
        color #2c3e50
        .pagination-custom-bullet
            border-radius .02rem
            width 48px
            height 4px
            margin 0px 2px
            display inline-block
            background white
            opacity 0.3
            transform skewX(-30deg)
            cursor pointer
        .pagination-custom-bullet-active
            background white
            opacity 1
            width 48px
            height 4px
            cursor pointer
    #nav
        padding 30px
        a
            font-weight bold
            color #2c3e50
            &.router-link-exact-active
                color #42b983
</style>
